// defining a constant
export const typesINPUT = {
    GET_MY_DATA_SUCCESS: 'GET_MY_DATA_SUCCESS',
    GET_MY_DATA_ERROR: 'GET_MY_DATA_ERROR',
    GET_MY_DATA_BEGIN: 'GET_MY_DATA_BEGIN'
}

